/**
 * Show more scroll web component.
 * On click, scrolls to #product-extra-information.
 */
class ShowMoreScroll extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this._handleClick = this._handleClick.bind(this);
    this.addEventListener("click", this._handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this._handleClick);
  }

  _handleClick(e) {
    const target = document.getElementById("product-extra-information");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }
}

customElements.define("show-more-scroll", ShowMoreScroll);
